import type { Components, Theme } from '@mui/material';

const menuThemeConfig: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {},
  },
};

const menuItemThemeConfig: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: '#ccf0f9',
      },
      '&.Mui-selected': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export const muiMenuThemeConfig = {
  MuiMenu: {
    ...menuThemeConfig,
  },
  MuiMenuItem: {
    ...menuItemThemeConfig,
  },
};
